import { Alert, Box, Button } from "@mui/material";
import { footerPrimaryButtonSx } from "@/shared/ui/dialogFooterButtons";

interface ErrorFallbackProps {
  message?: string;
}

/**
 * Fills the layout's main area when a route or panel could not be rendered. The
 * usual cause is a chunk that no longer exists because a deploy replaced the
 * hashed assets, and a reload is what picks up the new index.html — so that is
 * the only action offered.
 */
export default function ErrorFallback({
  message = "Something went wrong loading this page.",
}: Readonly<ErrorFallbackProps>) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        p: 3,
        bgcolor: "background.default",
      }}
    >
      <Alert severity="error" sx={{ maxWidth: 480 }}>
        {message}
      </Alert>
      <Button
        variant="contained"
        size="small"
        disableElevation
        onClick={() => {
          globalThis.window?.location.reload();
        }}
        sx={footerPrimaryButtonSx}
      >
        Reload
      </Button>
    </Box>
  );
}

/** Router adapter for `defaultErrorComponent`, which passes its own props. */
export function RouteErrorFallback() {
  return <ErrorFallback message="This page could not be loaded. Reloading usually fixes it." />;
}
